/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core'
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import moment from 'moment'

const CallNotification = (props) => {
  const getStartTimeDefault = (value) => {
    if (value === '00:01') {
      return moment().set({ hour: 0, minute: 1 })
    } else {
      return moment(value, 'HH:mm')
    }
  }

  const getEndTimeDefault = (value) => {
    if (value === '23:59') {
      return moment().set({ hour: 23, minute: 59 })
    } else {
      return moment(value, 'HH:mm')
    }
  }
  const dataLoaded = props.callData

  const [isLoadedDataThreshold, setIsLoadedDataThreshold] = useState(true)
  const [isLoadedDataGateways, setIsLoadedDataGateways] = useState(true)

  const [thresholdAlerts, setThresholdAlerts] = useState<boolean>(
    dataLoaded.allowSendThreshold
  )
  const [yellowThresholdAlerts, setYellowThresholdAlerts] = useState<boolean>(
    dataLoaded.allowSendThresholdYellow
  )
  const [applyHoursForYellowAlerts, setApplyHoursForYellowAlerts] =
    useState<boolean>(dataLoaded.allowSendThresholdYellowHours)
  const [startTimeFromPickerYellow, setStartTimeFromPickerYellow] = useState(
    getStartTimeDefault(dataLoaded.startTimeThresholdYellowHours)
  )
  const [endTimeFromPickerYellow, setEndTimeFromPickerYellow] = useState(
    getEndTimeDefault(dataLoaded.endTimeThresholdYellowHours)
  )

  const [redThresholdAlerts, setRedThresholdAlerts] = useState<boolean>(
    dataLoaded.allowSendThresholdRed
  )
  const [applyHoursForRedAlerts, setApplyHoursForRedAlerts] = useState<boolean>(
    dataLoaded.allowSendThresholdRedHours
  )
  const [startTimeFromPickerRed, setStartTimeFromPickerRed] = useState(
    getStartTimeDefault(dataLoaded.startTimeThresholdRedHours)
  )
  const [endTimeFromPickerRed, setEndTimeFromPickerRed] = useState(
    getEndTimeDefault(dataLoaded.endTimeThresholdRedHours)
  )

  const [gatewayAlerts, setGatewayAlerts] = useState<boolean>(
    dataLoaded.allowSendGateway
  )
  const [redThresholdAlertsGateway, setRedThresholdAlertsGateway] =
    useState<boolean>(dataLoaded.allowSendGatewayRed)
  const [applyHoursForRedAlertsGateway, setApplyHoursForRedAlertsGateway] =
    useState<boolean>(dataLoaded.allowSendGatewayRedHours)
  const [startTimeFromPickerRedGateway, setStartTimeFromPickerRedGateway] =
    useState(getStartTimeDefault(dataLoaded.startTimeGatewayRedHours))
  const [endTimeFromPickerRedGateway, setEndTimeFromPickerRedGateway] =
    useState(getEndTimeDefault(dataLoaded.endTimeGatewayRedHours))

  const [allowHighPriorityAlerts, setAllowHighPriorityAlerts] =
    useState<boolean>(dataLoaded.allowSendHighPriority)
  const [callAttempts, setCallAttempts] = useState(dataLoaded.callAttempts)

  const setToggle = (setter) => (event) => {
    setter(event.target.checked)
  }

  const setDate = (setter) => (event) => {
    setter(event)
  }

  const setNumber = (setter) => (event) => {
    setter(event.target.value)
  }

  useEffect(() => {
    if (!thresholdAlerts) {
      setYellowThresholdAlerts(false)
      setApplyHoursForYellowAlerts(false)
      setRedThresholdAlerts(false)
      setApplyHoursForRedAlerts(false)
      setIsLoadedDataThreshold(false)
      setApplyHoursForYellowAlerts(
        dataLoaded.startTimeThresholdYellowHours !== '00:01' &&
          dataLoaded.endTimeThresholdYellowHours !== '23:59'
      )
      setApplyHoursForRedAlerts(
        dataLoaded.startTimeThresholdRedHours !== '00:01' &&
          dataLoaded.endTimeThresholdRedHours !== '23:59'
      )
    } else {
      if (!isLoadedDataThreshold) {
        setYellowThresholdAlerts(true)
        setRedThresholdAlerts(true)
      } else {
        setIsLoadedDataThreshold(false)
        setYellowThresholdAlerts(dataLoaded.allowSendThresholdYellow)
        setApplyHoursForYellowAlerts(
          dataLoaded.startTimeThresholdYellowHours !== '00:01' &&
            dataLoaded.endTimeThresholdYellowHours !== '23:59'
        )
        setRedThresholdAlerts(dataLoaded.allowSendThresholdRed)
        setApplyHoursForRedAlerts(
          dataLoaded.startTimeThresholdRedHours !== '00:01' &&
            dataLoaded.endTimeThresholdRedHours !== '23:59'
        )
      }
    }
  }, [thresholdAlerts])

  useEffect(() => {
    if (!gatewayAlerts) {
      setIsLoadedDataGateways(false)
      setRedThresholdAlertsGateway(false)
      setApplyHoursForRedAlertsGateway(false)
      setStartTimeFromPickerRedGateway(getStartTimeDefault('00:01'))
      setEndTimeFromPickerRedGateway(getEndTimeDefault('23:59'))
    } else {
      if (!isLoadedDataGateways) {
        setRedThresholdAlertsGateway(true)
      } else {
        setIsLoadedDataGateways(false)
        setRedThresholdAlertsGateway(dataLoaded.allowSendGatewayRed)
        setApplyHoursForRedAlertsGateway(
          dataLoaded.startTimeGatewayRedHours !== '00:01' ||
            dataLoaded.endTimeGatewayRedHours !== '23:59'
        )
        setStartTimeFromPickerRedGateway(
          getStartTimeDefault(dataLoaded.startTimeGatewayRedHours)
        )
        setEndTimeFromPickerRedGateway(
          getEndTimeDefault(dataLoaded.endTimeGatewayRedHours)
        )
      }
    }
  }, [gatewayAlerts])

  useEffect(() => {
    if (!yellowThresholdAlerts) {
      setApplyHoursForYellowAlerts(false)
      setStartTimeFromPickerYellow(
        getStartTimeDefault(getStartTimeDefault('00:01'))
      )
      setEndTimeFromPickerYellow(getEndTimeDefault(getEndTimeDefault('23:59')))
    }
  }, [yellowThresholdAlerts])

  useEffect(() => {
    if (!redThresholdAlerts) {
      setApplyHoursForRedAlerts(false)
      setStartTimeFromPickerRed(
        getStartTimeDefault(getStartTimeDefault('00:01'))
      )
      setEndTimeFromPickerRed(getEndTimeDefault(getEndTimeDefault('23:59')))
    }
  }, [redThresholdAlerts])

  useEffect(() => {
    if (!yellowThresholdAlerts && !redThresholdAlerts) {
      setThresholdAlerts(false)
    }
  }, [yellowThresholdAlerts, redThresholdAlerts])

  useEffect(() => {
    if (!redThresholdAlertsGateway) {
      setApplyHoursForRedAlertsGateway(false)
      setStartTimeFromPickerRedGateway(
        getStartTimeDefault(dataLoaded.startTimeGatewayRedHours)
      )
      setEndTimeFromPickerRedGateway(
        getEndTimeDefault(dataLoaded.endTimeGatewayRedHours)
      )
      setGatewayAlerts(false)
    }
  }, [redThresholdAlertsGateway])

  useEffect(() => {
    if (!applyHoursForYellowAlerts) {
      setStartTimeFromPickerYellow(getStartTimeDefault('00:01'))
      setEndTimeFromPickerYellow(getEndTimeDefault('23:59'))
    }
  }, [applyHoursForYellowAlerts])

  useEffect(() => {
    if (!applyHoursForRedAlerts) {
      setStartTimeFromPickerRed(getStartTimeDefault('00:01'))
      setEndTimeFromPickerRed(getEndTimeDefault('23:59'))
    }
  }, [applyHoursForRedAlerts])

  useEffect(() => {
    if (!applyHoursForRedAlertsGateway) {
      setStartTimeFromPickerRedGateway(getStartTimeDefault('00:01'))
      setEndTimeFromPickerRedGateway(getEndTimeDefault('23:59'))
    }
  }, [applyHoursForRedAlertsGateway])

  useEffect(() => {
    sendData()
  }, [
    thresholdAlerts,
    yellowThresholdAlerts,
    startTimeFromPickerYellow,
    endTimeFromPickerYellow,
    redThresholdAlerts,
    startTimeFromPickerRed,
    endTimeFromPickerRed,
    gatewayAlerts,
    redThresholdAlertsGateway,
    startTimeFromPickerRedGateway,
    endTimeFromPickerRedGateway,
    allowHighPriorityAlerts,
    callAttempts,
  ])

  const sendData = () => {
    const data = {
      allowSendThreshold: thresholdAlerts,
      allowSendThresholdYellow: yellowThresholdAlerts,
      startTimeThresholdYellowHours: moment(startTimeFromPickerYellow).format(
        'HH:mm'
      ),
      endTimeThresholdYellowHours: moment(endTimeFromPickerYellow).format(
        'HH:mm'
      ),

      allowSendThresholdRed: redThresholdAlerts,
      startTimeThresholdRedHours: moment(startTimeFromPickerRed).format(
        'HH:mm'
      ),
      endTimeThresholdRedHours: moment(endTimeFromPickerRed).format('HH:mm'),

      allowSendGateway: gatewayAlerts,
      allowSendGatewayRed: redThresholdAlertsGateway,
      startTimeGatewayRedHours: moment(startTimeFromPickerRedGateway).format(
        'HH:mm'
      ),
      endTimeGatewayRedHours: moment(endTimeFromPickerRedGateway).format(
        'HH:mm'
      ),

      allowSendHighPriority: allowHighPriorityAlerts,
      callAttempts: callAttempts,
    }
    props.onData(data)
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography>Call Notifications</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography style={{ marginLeft: '15px' }}>
          {props.phoneNumber}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="caption" style={{ marginLeft: '15px' }}>
          Change the phone number in the upper field
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ marginTop: '30px' }}>
        <Typography>Notify me via call about these activities</Typography>
      </Grid>
      <Grid item xs={12}>
        <FormGroup style={{ marginLeft: '15px' }}>
          <div style={{ maxHeight: '250px' }}>
            <FormControlLabel
              label="Thresholds Alerts"
              control={
                <Checkbox
                  // defaultChecked
                  checked={thresholdAlerts}
                  color="primary"
                  onChange={setToggle(setThresholdAlerts)}
                  size="small"
                />
              }
            />

            {thresholdAlerts && (
              <>
                <hr />
                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <FormControlLabel
                      label={
                        <Typography>
                          Notify me of <b>yellow</b> alerts
                        </Typography>
                      }
                      control={
                        <Checkbox
                          // defaultChecked
                          checked={yellowThresholdAlerts}
                          color="primary"
                          onChange={setToggle(setYellowThresholdAlerts)}
                          size="small"
                        />
                      }
                    />
                    {yellowThresholdAlerts && (
                      <Grid container>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={11}>
                          <FormControlLabel
                            label="Apply Hours for Alerts"
                            control={
                              <Checkbox
                                // defaultChecked
                                checked={applyHoursForYellowAlerts}
                                color="primary"
                                onChange={setToggle(
                                  setApplyHoursForYellowAlerts
                                )}
                                size="small"
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                  {applyHoursForYellowAlerts && (
                    <>
                      <Grid item xs={3}>
                        <div>
                          <Typography color="primary" variant="h6">
                            Start Time
                          </Typography>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <TimePicker
                              value={startTimeFromPickerYellow}
                              // disabled={props.isSameBusinessHoursForSmsAndCalls}
                              onChange={setDate(setStartTimeFromPickerYellow)}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <Typography color="primary" variant="h6">
                            End Time
                          </Typography>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <TimePicker
                              // disabled={props.isSameBusinessHoursForSmsAndCalls}
                              value={endTimeFromPickerYellow}
                              onChange={setDate(setEndTimeFromPickerYellow)}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            )}
            {thresholdAlerts && (
              <>
                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <FormControlLabel
                      label={
                        <Typography>
                          Notify me of <b>red</b> alerts
                        </Typography>
                      }
                      control={
                        <Checkbox
                          // defaultChecked
                          checked={redThresholdAlerts}
                          color="primary"
                          onChange={setToggle(setRedThresholdAlerts)}
                          size="small"
                        />
                      }
                    />
                    {redThresholdAlerts && (
                      <Grid container>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={11}>
                          <FormControlLabel
                            label="Apply Hours for Alerts"
                            control={
                              <Checkbox
                                // defaultChecked
                                checked={applyHoursForRedAlerts}
                                color="primary"
                                onChange={setToggle(setApplyHoursForRedAlerts)}
                                size="small"
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                  {applyHoursForRedAlerts && (
                    <>
                      <Grid item xs={3}>
                        <div>
                          <Typography color="primary" variant="h6">
                            Start Time
                          </Typography>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <TimePicker
                              value={startTimeFromPickerRed}
                              // disabled={props.isSameBusinessHoursForSmsAndCalls}
                              onChange={setDate(setStartTimeFromPickerRed)}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <Typography color="primary" variant="h6">
                            End Time
                          </Typography>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <TimePicker
                              // disabled={props.isSameBusinessHoursForSmsAndCalls}
                              value={endTimeFromPickerRed}
                              onChange={setDate(setEndTimeFromPickerRed)}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            )}
          </div>
          <div
            style={{
              maxHeight: '150px',
              display: props.isSuperVisor ? 'block' : 'none',
            }}
            // style={{
            //
            // }}
          >
            <FormControlLabel
              label="Gateway Battery Alerts"
              control={
                <Checkbox
                  checked={gatewayAlerts}
                  color="primary"
                  onChange={setToggle(setGatewayAlerts)}
                  size="small"
                />
              }
            />
            {gatewayAlerts && (
              <>
                <hr />
                <Grid container>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={5}>
                    <FormControlLabel
                      label={
                        <Typography>
                          Notify me of <b>red</b> alerts
                        </Typography>
                      }
                      control={
                        <Checkbox
                          // defaultChecked
                          checked={redThresholdAlertsGateway}
                          color="primary"
                          onChange={setToggle(setRedThresholdAlertsGateway)}
                          size="small"
                        />
                      }
                    />
                    {redThresholdAlertsGateway && (
                      <Grid container>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={11}>
                          <FormControlLabel
                            label="Apply Hours for Alerts"
                            control={
                              <Checkbox
                                // defaultChecked
                                checked={applyHoursForRedAlertsGateway}
                                color="primary"
                                onChange={setToggle(
                                  setApplyHoursForRedAlertsGateway
                                )}
                                size="small"
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                  {applyHoursForRedAlertsGateway && (
                    <>
                      <Grid item xs={3}>
                        <div>
                          <Typography color="primary" variant="h6">
                            Start Time
                          </Typography>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <TimePicker
                              value={startTimeFromPickerRedGateway}
                              // disabled={props.isSameBusinessHoursForSmsAndCalls}
                              onChange={setDate(
                                setStartTimeFromPickerRedGateway
                              )}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Grid>
                      <Grid item xs={3}>
                        <div>
                          <Typography color="primary" variant="h6">
                            End Time
                          </Typography>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <TimePicker
                              // disabled={props.isSameBusinessHoursForSmsAndCalls}
                              value={endTimeFromPickerRedGateway}
                              onChange={setDate(setEndTimeFromPickerRedGateway)}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            )}
          </div>
          <div
            style={{
              display: props.isUserAdmin ? 'block' : 'none',
            }}
          >
            <FormControlLabel
              label="High Priority Alerts"
              control={
                <Checkbox
                  checked={allowHighPriorityAlerts}
                  color="primary"
                  onChange={setToggle(setAllowHighPriorityAlerts)}
                  size="small"
                />
              }
            />
          </div>
          <div
          // style={{
          //   display: props.isUserAdmin ? 'block' : 'none',
          // }}
          >
            <Grid item xs={12}>
              <div>
                <Typography color="primary" variant="h6">
                  Call attempts
                </Typography>
                <div>
                  <TextField
                    type="number"
                    InputProps={{
                      inputProps: { min: 1 },
                    }}
                    value={callAttempts}
                    onChange={setNumber(setCallAttempts)}
                  />
                </div>
              </div>
            </Grid>
          </div>
        </FormGroup>
      </Grid>
    </Grid>
  )
}

export default CallNotification
